module.exports = __webpack_public_path__ + "static/courtenay-02b7cbcd4d286baa3b98c1a2c4d61648.jpg";